<template>
  <audio ref="audioRef" preload="auto">
    <source :src="srcMp3" type="audio/mpeg" />
    <source :src="srcWebm" type="audio/webm" />
  </audio>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
  srcMp3: {
    type: String,
    default: '/sounds/chime.mp3',
  },
  srcWebm: {
    type: String,
    default: '/sounds/chime.webm',
  },
});

const audioRef = ref(null);

const play = () => {
  if (audioRef.value) {
    // Always rewind before playing
    audioRef.value.currentTime = 0;
    audioRef.value.play().catch((err) => {
      // eslint-disable-next-line no-console
      console.warn('Audio playback failed:', err);
    });
  }
};

defineExpose({ play });
</script>
